// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { DefaultQueries } from '../../../../types/server/modules/default/queries';

export type * from '../../../../types/server/modules/default/queries';

export const createQueries = ( requests: Requests ): DefaultQueries => ({
  AutomationRequestsReviewQueue: ( params?, headers? ) => {
        return requests.get( `/automation-requests-review-queue`, params, headers );
      },
  AutomationRequestsQueueHealth: ( params?, headers? ) => {
        return requests.get( `/automation-requests-queue-health`, params, headers );
      },
  AutomationRequestsOutcomeCounts: ( params?, headers? ) => {
        return requests.get( `/automation-requests-outcome-counts`, params, headers );
      },
  AutomationRequestsGapBacklog: ( params?, headers? ) => {
        return requests.get( `/automation-requests-gap-backlog`, params, headers );
      },
  BillingProfilesById: ( id, query, headers ) => { 
          return requests.get( `/billing/profiles/${id}`, query, headers ); 
        },
  BillingProfiles: ( params?, headers? ) => {
        return requests.get( `/billing/profiles/:id?`, params, headers );
      },
  BillingAccountsById: ( id, query, headers ) => { 
          return requests.get( `/billing/accounts/${id}`, query, headers ); 
        },
  BillingAccounts: ( params?, headers? ) => {
        return requests.get( `/billing/accounts/:id?`, params, headers );
      },
  BillingContractsById: ( id, query, headers ) => { 
          return requests.get( `/billing/contracts/${id}`, query, headers ); 
        },
  BillingContracts: ( params?, headers? ) => {
        return requests.get( `/billing/contracts/:id?`, params, headers );
      },
  BillingSubscriptionInvoicesById: ( id, query, headers ) => { 
          return requests.get( `/billing/subscriptionInvoices/${id}`, query, headers ); 
        },
  BillingSubscriptionInvoices: ( params?, headers? ) => {
        return requests.get( `/billing/subscriptionInvoices/:id?`, params, headers );
      },
  BillingPaymentsById: ( id, query, headers ) => { 
          return requests.get( `/billing/payments/${id}`, query, headers ); 
        },
  BillingPayments: ( params?, headers? ) => {
        return requests.get( `/billing/payments/:id?`, params, headers );
      },
  BillingMyPaymentsById: ( id, query, headers ) => { 
          return requests.get( `/billing/my-payments/${id}`, query, headers ); 
        },
  BillingMyPayments: ( params?, headers? ) => {
        return requests.get( `/billing/my-payments/:id?`, params, headers );
      },
  BillingCreditsById: ( id, query, headers ) => { 
          return requests.get( `/billing/credits/${id}`, query, headers ); 
        },
  BillingCredits: ( params?, headers? ) => {
        return requests.get( `/billing/credits/:id?`, params, headers );
      },
  BillingDebitsById: ( id, query, headers ) => { 
          return requests.get( `/billing/debits/${id}`, query, headers ); 
        },
  BillingDebits: ( params?, headers? ) => {
        return requests.get( `/billing/debits/:id?`, params, headers );
      },
  BillingBalancesById: ( id, query, headers ) => { 
          return requests.get( `/billing/balances/${id}`, query, headers ); 
        },
  BillingBalances: ( params?, headers? ) => {
        return requests.get( `/billing/balances/:id?`, params, headers );
      },
  BillingActivity: ( params?, headers? ) => {
        return requests.get( `/billing/activity/:accountId?`, params, headers );
      },
  BillingGatewayOrphansById: ( id, query, headers ) => { 
          return requests.get( `/billing/gateway/orphans/${id}`, query, headers ); 
        },
  BillingGatewayOrphans: ( params?, headers? ) => {
        return requests.get( `/billing/gateway/orphans/:id?`, params, headers );
      },
  BillingGatewayOrphansSearch: ( params?, headers? ) => {
        return requests.get( `/billing/gateway/orphans-search`, params, headers );
      },
  BillingDunningProcessesById: ( id, query, headers ) => { 
          return requests.get( `/billing/dunning-processes/${id}`, query, headers ); 
        },
  BillingDunningProcesses: ( params?, headers? ) => {
        return requests.get( `/billing/dunning-processes/:id?`, params, headers );
      }
});
